export default __webpack_public_path__ + "navigation-overview-carplay-960-fe0f6ac17fcfe5dbd7ba88d5e807eecd.png";